import { getContext } from '@/context';
import { getAppStore } from '@/store';

export const PORTFOLIO_APP_TOUCH_POINT = 'com.picsart.apps.genai';

/** SDK location route contains the gen-ai segment (editor host's gen-ai section). */
export const isGenaiRoute = (): boolean => {
  try {
    const route = getContext().general.location.getState?.()?.route ?? '';
    // eslint-disable-next-line no-restricted-syntax -- canonical source of the surface check; callers use this predicate
    return route.includes('gen-ai');
  } catch {
    return false;
  }
};

export const isStandaloneSurface = (): boolean =>
  isGenaiRoute() || getAppStore().appExperience === 'landing';
